import { render, staticRenderFns } from "./NotificationAssignments.vue?vue&type=template&id=4ade788d&scoped=true"
import script from "./NotificationAssignments.vue?vue&type=script&lang=js"
export * from "./NotificationAssignments.vue?vue&type=script&lang=js"
import style0 from "./NotificationAssignments.vue?vue&type=style&index=0&id=4ade788d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade788d",
  null
  
)

export default component.exports